<template lang="pug">
  .tag-form
    b-field(v-if="value.id" label="Статус*", :type="errors && errors.status ? 'is-danger' : ''", :message="errors.status")
      b-select(v-model="value.is_active")
        option(:value="true")
          | Активна
        option(:value="false")
          | В архиве

    b-field(label="Название*", :type="errors && errors.name ? 'is-danger' : ''", :message="errors.name")
      b-input(v-model="value.name")

    b-field(label="Цвет*", :type="errors && errors.color ? 'is-danger' : ''", :message="errors.color")
      span(v-for="(value, key) in value.colors" :key="key" :class="'tag ' + value", style="cursor:pointer; margin-right: 5px;" @click="selectColor(value)")
        | &nbsp;&nbsp;&nbsp;

    | Пример: &nbsp;
    span(:class="'tag ' + value.color")
      | {{ demoName }}

</template>

<script>
import BSelect from 'buefy/src/components/select/Select';

export default {
  name: 'tag-form',
  components: { BSelect },
  props: {
    value: Object,
    errors: Object,
  },

  computed: {
    demoName() {
      return this.value.name === '' ? 'Метка' : this.value.name;
    },
  },

  methods: {
    afterSave() {},

    selectColor(value) {
      this.value.color = value;
    },
  },

  created() {
    if (this.value.color === '') {
      this.value.color = this.value.colors[0];
    }
  },
};
</script>

<style scoped></style>
